/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { setCookie } from "../cookie/cookie";

// Storage for PKCE verifier
const PKCE_STORAGE_KEY_FSBO = "pkce_verifier_fsbo";

function base64UrlEncode(buffer: Uint8Array): string {
    const base64 = btoa(String.fromCharCode(...buffer));
    return base64
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
}

export function generateCodeVerifier() {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return base64UrlEncode(array);
}

export async function generateCodeChallenge(codeVerifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hash = await crypto.subtle.digest("SHA-256", data);
    return base64UrlEncode(new Uint8Array(hash));
}

export async function generatePKCEPair() {
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = await generateCodeChallenge(codeVerifier);
    return { codeVerifier: codeVerifier, codeChallenge: codeChallenge };
}

export function storePKCEVerifier(codeVerifier: any): void {
    setCookie(PKCE_STORAGE_KEY_FSBO, codeVerifier, { "domain": process.env.VUE_APP_ROOT_URL, "path": "/", "expires": 0.021 }); // 30 minutes
}

export function generateNonce() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return base64UrlEncode(array);
}

export async function generateOAuthSecurityParams() {
    const { codeVerifier, codeChallenge } = await generatePKCEPair();
    const nonce = generateNonce();
    return { codeVerifier: codeVerifier, codeChallenge: codeChallenge, nonce: nonce };
}
